import apexchartsRu from 'apexcharts/dist/locales/ru.json';
import dayjs from 'dayjs';
import { Kazakh } from 'flatpickr/dist/l10n/kz';
import { Russian } from 'flatpickr/dist/l10n/ru';
import { i18n } from '@/i18n';
import { Locale } from '@/i18n/config';
import apexchartsKk from '@/i18n/vendors/apexchartsKk';
import 'dayjs/locale/kk';
import 'dayjs/locale/ru';

/**
 * Локали сторонних библиотек под текущий язык.
 * Язык меняется только с перезагрузкой страницы (setLocale), поэтому считаем один раз
 */
const isKk = i18n.locale === Locale.KK;

dayjs.locale(i18n.locale);

export const flatpickrLocale = isKk ? Kazakh : Russian;

export const apexchartsLocale = {
    defaultLocale: i18n.locale,
    locales:       [apexchartsRu, apexchartsKk],
};
